module.exports = __webpack_public_path__ + "img/fi-rr-menu-dots-vertical.9e917d2a.svg";